module.exports = __webpack_public_path__ + "img/logo_pingodoce.fef3377a.svg";